import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { ReactElement } from "react";

import BaseCTAVisual from "@/components/CallToActions/BaseCTAVisual/baseCTAVisual.component";
import { CTAActions } from "@/redux/modules/api/data/cart/@types/cart.types";

const baseCTAVisual = (
    product: CartItem | null,
    action: CTAActions
): ReactElement => (
    <BaseCTAVisual
        type={action.type}
        sku={product?.sku}
    />
);

export default baseCTAVisual;
